import React from 'react';
import { JiraServiceManagementIcon } from '@atlaskit/logo';
import { Box, xcss } from '@atlaskit/primitives';
import { useDatasourceAnalyticsEvents } from '../../../analytics';
var jsmTextStyles = xcss({
  fontSize: 'small',
  color: 'color.text.subtle',
  marginLeft: 'space.075',
  ':hover': {
    color: 'color.link.pressed'
  }
});
var jsmContainerStyles = xcss({
  display: 'flex',
  flexDirection: 'row-reverse'
});
export var PoweredByJSMAssets = function PoweredByJSMAssets(props) {
  var ASSETS_LINK = '/jira/servicedesk/assets';
  var _useDatasourceAnalyti = useDatasourceAnalyticsEvents(),
    fireEvent = _useDatasourceAnalyti.fireEvent;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: jsmContainerStyles,
    padding: "space.150"
  }, /*#__PURE__*/React.createElement("a", {
    "data-testid": 'powered-by-jsm-assets-link',
    onClick: function onClick() {
      return fireEvent('ui.link.clicked.poweredBy', {
        componentHierarchy: 'datasourceTable',
        extensionKey: 'jsm-cmdb-gateway'
      });
    },
    href: ASSETS_LINK,
    rel: "noreferrer",
    target: "_blank",
    style: {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      display: 'inline-flex',
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(JiraServiceManagementIcon, {
    size: "xsmall",
    appearance: "brand",
    label: props.text
  }), /*#__PURE__*/React.createElement(Box, {
    xcss: jsmTextStyles
  }, props.text)));
};